import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/api';
import toast from 'react-hot-toast';

const StudentLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log('🔐 Student Login Attempt:', formData.email);
      
      const response = await authService.login(formData);
      console.log('✅ Login Response:', response.data);
      
      if (response.data.success) {
        const { token, ...user } = response.data.data;
        
        // ✅ STORE IN LOCALSTORAGE
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('userRole', user.role);
        localStorage.setItem('studentId', user._id);
        
        // ✅ VERIFY
        console.log('✅ Token stored:', localStorage.getItem('token') ? 'YES' : 'NO');
        console.log('✅ User stored:', localStorage.getItem('user') ? 'YES' : 'NO');
        console.log('✅ Role:', localStorage.getItem('userRole'));
        console.log('✅ Student ID:', localStorage.getItem('studentId'));
        
        toast.success(`Welcome ${user.name}!`);
        
        // ✅ REDIRECT
        if (user.role === 'student') {
          navigate('/vsw-student', { replace: true });
        } else {
          toast.error('Invalid student credentials');
        }
      }
    } catch (error) {
      console.error('❌ Login Error:', error);
      const message = error.response?.data?.message || 'Login failed. Please try again.';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const fillCredentials = () => {
    setFormData({
      email: 'student@example.com',
      password: 'student123'
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-blue-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-2xl shadow-xl">
        <div>
          <div className="text-center">
            <div className="text-5xl mb-4">👨‍🎓</div>
            <h2 className="text-3xl font-extrabold text-gray-900">
              Student Login
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              Vidya Bharati School
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={fillCredentials}
          className="w-full py-2 text-sm font-medium text-green-600 bg-green-50 rounded-lg hover:bg-green-100 transition"
        >
          📝 Auto-fill Demo Credentials
        </button>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email Address
              </label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                placeholder="student@example.com"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Password
              </label>
              <input
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                placeholder="student123"
                required
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-green-600 text-white py-3 rounded-lg hover:bg-green-700 transition disabled:opacity-50"
          >
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <div className="text-center text-sm text-gray-500 bg-gray-50 p-4 rounded-lg">
          <p className="font-semibold text-gray-700">Demo Credentials:</p>
          <p className="text-green-600">student@example.com / student123</p>
        </div>
      </div>
    </div>
  );
};

export default StudentLogin;
